import Menu from "./components/Menu"

const MenuPage = () => {
  return <Menu />
}

export default MenuPage
